var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "29px",
    viewBox: "0 0 15 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/temp/grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walkin-out-Live-view-Copy",
    transform: "translate(-311.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(79.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "human-id",
    transform: "translate(13.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/temp/grey",
    transform: "translate(220.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54036364,16.0236034 C9.00469267,16.5658154 10.0538182,18.028841 10.0538182,19.7485714 C10.0538182,21.9299384 8.36585029,23.6982857 6.28363636,23.6982857 C4.20142244,23.6982857 2.51345455,21.9299384 2.51345455,19.7485714 C2.51345455,18.028841 3.56258006,16.5658154 5.02690909,16.0236034 L5.02690909,7.76571429 L7.54036364,7.76571429 L7.54036364,16.0236034 Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57727273,14.8495056 L2.57727273,3.86590909 C2.57727273,1.73082646 4.30809918,3.92208317e-16 6.44318182,0 C8.57826445,-3.92208317e-16 10.3090909,1.73082646 10.3090909,3.86590909 L10.3090909,14.8495056 C11.8740711,16.0809842 12.8863636,18.0416459 12.8863636,20.25 C12.8863636,23.9779221 10.0016529,27 6.44318182,27 C2.88471076,27 0,23.9779221 0,20.25 C0,18.0416459 1.01229255,16.0809842 2.57727273,14.8495056 Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.06666667
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureGrey);
export default __webpack_public_path__ + "static/media/temperature_grey.953cf31f1bd619319c86e76e8907e810.svg";
export { ForwardRef as ReactComponent };